import PosthogService from '~/services/posthog/PosthogService';

export type TAutoConfirmToggleName = 'favorites' | 'eligible_professionals';

export interface IShiftRequestAutoconfirmToggleAttemptedPayload {
  officeId: string;
  toggle: TAutoConfirmToggleName;
  /** Attempts on a locked toggle so far in this visit. */
  attemptCount: number;
}

/**
 * Fires on every click of an Auto-Confirm toggle the last-minute experiment has locked on
 * (GOTU-5437) — whether offices try to opt out before posting anyway.
 *
 * `funnelEntryId` is attached automatically, which is what separates "three attempts in one
 * visit" from "one attempt across three visits".
 * Event: dental_portal:shift_request:autoconfirm_toggle_attempted
 */
export function fireShiftRequestAutoconfirmToggleAttempted(
  payload: IShiftRequestAutoconfirmToggleAttemptedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:shift_request:autoconfirm_toggle_attempted', {
    office_id: payload.officeId,
    toggle: payload.toggle,
    attempt_count: payload.attemptCount,
    'Design Date': 202603,
  });
}
